module.exports = __webpack_public_path__ + "static/media/darshan.8fba7b85.jpg";